import { Typography } from '@mui/material';
import React from 'react';
import { TitleRow } from './TableHeadRowSuccessStrapi.styled';
import { useTranslation } from 'next-i18next';

export const TableHeadRowSuccessStrapi = () => {
  const { t } = useTranslation();
  return (
    <TitleRow>
      <Typography variant={'averageMob450'} color={'#96A0B5'}>
        {t('app.cart.product')}
      </Typography>
      <Typography variant={'averageMob450'} color={'#96A0B5'}>
        {t('app.cart.date')}
      </Typography>
      <Typography variant={'averageMob450'} color={'#96A0B5'}>
        {t('app.cart.voucher_code')}
      </Typography>
      <Typography variant={'averageMob450'} color={'#96A0B5'}>
        {t('app.profilePage.action')}
      </Typography>
    </TitleRow>
  );
};
